import filterOptions from './filterOptions'

const {
  checkboxProvidersOptions,
  generalProviderType,
  providersWithGeneral,
  providers,
  creatorType,
  compareTabs,
  searchCreatorsSortBy,
  searchCreatorsTopicSortBy,
  videosSortBy,
  videosSortByCreatorTwitch,
  tagListSortBy,
  genders,
  ages,
  audienceCountries,
  dateRangeSearch,
  uploadDateSearchVideos,
  uploadDateSearchTopics,
  customUploadDateRangeSearchVideos,
  dataRangeChart,
  language,
  countries,
  sortByAvgViewsEngagement,
  creatorPerformanceSortBy,
  topicPerformanceSortBy,
  length,
  likes,
  comments,
  cultureTopicsSortBy,
  cultureSubtopicsSortBy,
  chartLogic,
  engagement,
  views,
  subtopicType,
  creatorTier,
  topicCategory,
  subtopicTopic,
  subtopicCategory,
  subtopic,
  topic,
  formatId,
  title,
  subtopicSearchTerm,
  searchTopicType,
  searchSubtopicType,
  followedCreators,
  trendingCreators,
  musicGenre,
  musicSubgenre,
  dateRangeButtons,
  tagTitle,
  uploadTrendingDates,
  dataRangeCompare,
  isLive,
  isAdvertisement,
  compareTopicsRelevanceLogic,
  titleAnd,
  titleOr,
  titleNot,
  youtubeAuditDataRangeCompare,
} = filterOptions

// Defaults
const newVideosDefaultValues = {
  sortBy: videosSortBy[0],
  sortByOptions: videosSortBy,
  providers: checkboxProvidersOptions,
  topics: topic[0],
  formatIds: formatId[0],
  topicCategory: topicCategory[0],
  musicGenre: musicGenre[0],
  musicSubgenre: musicSubgenre[0],
  subtopic: subtopic[0],
  countries: countries[0],
  countriesOptions: countries,
  dateRange: dateRangeSearch[0],
  uploadDate: customUploadDateRangeSearchVideos[4],
  uploadDateOptions: customUploadDateRangeSearchVideos,
  language: language[3],
  likes: likes[0],
  lengthMin: length[0],
  lengthMax: length[length?.length - 1],
  lengthOptions: length,
  comments: comments[0],
  engagement: engagement[0],
  views: views[0],
  title: title[0],
  languages: [language[3]],
  categories: [topicCategory[0]],
  subtopics: [subtopic[0]],
  isLive,
  isAdvertisement,
}

const filterDefaults = {
  topicTagsTab: {
    sortBy: tagListSortBy[0],
  },
  audience: {
    genders: genders[0],
    ages: ages[0],
    countries: countries[0],
    dateRange: dateRangeSearch[1],
    language: language[0],
    category: { label: 'All', value: [] },
    creatorTier: creatorTier[0],
  },
  chart: {
    sortByAvgViewsEngagement: sortByAvgViewsEngagement[0],
    creatorPerformanceSortBy: creatorPerformanceSortBy[0],
    topicPerformanceSortBy: topicPerformanceSortBy[0],
    cultureTopicsSortBy: cultureTopicsSortBy[0],
    cultureSubtopicsSortBy: cultureSubtopicsSortBy[0],
    providers: checkboxProvidersOptions,
    chartLogic: chartLogic[0],
    dateRange: dataRangeChart[0],
    compareTopicsRelevanceLogic: compareTopicsRelevanceLogic[0],
  },
  topics: {
    genders: genders[0],
    ages: ages[0],
    countries: countries[0],
    language: language[0],
    dateRange: dateRangeSearch[0],
  },
  audienceFilters: {
    audienceGenders: genders[0],
    audienceAges: ages[0],
    audienceCountries: audienceCountries[0],
  },
  comparePage: {
    comparing: compareTabs[0],
    dateRange: dataRangeCompare[2],
    creators: [],
    subtopics: [],
    topics: [],
    savedPostSearches: [],
    niches: [],
    tags: [],
    industry_topic: [],
    global_topic: [],
    theme: [],
    segment: [],
    subject: [],
    entity_query: [],
    entity: [],
  },
  topicPeopleAlsoWatchTab: {
    title: title[0],
  },
  searchTopicsPage: {
    language: language[0],
    topicCategory: topicCategory[0],
    subtopicTopic: subtopicTopic[0],
    subtopicCategory: subtopicCategory[0],
    searchTopicType: searchTopicType[0],
    searchSubtopicType: searchSubtopicType[0],
    dateRange: uploadDateSearchTopics[0],
    dateRangeOptions: uploadDateSearchTopics,
  },
  jobTopicsTab: {
    language: language[3],
    topicCategory: topicCategory[0],
    subtopicTopic: subtopicTopic[0],
    subtopicCategory: subtopicCategory[0],
    searchTopicType: searchTopicType[0],
    searchSubtopicType: searchSubtopicType[0],
    dateRange: uploadDateSearchTopics[0],
    dateRangeOptions: uploadDateSearchTopics,
  },
  newSubtopic: {
    subtopicType: subtopicType[0],
    subtopicTypeOptions: subtopicType,
    language: language[0],
    subtopicTopic: subtopicTopic[0],
    subtopicCategory: subtopicCategory[0],
    subtopicSearchTerm: subtopicSearchTerm[0],
  },
  newVideos: {
    ...newVideosDefaultValues,
  },
  newVideosCreatorTwitch: {
    ...newVideosDefaultValues,
    sortBy: videosSortByCreatorTwitch[0],
    sortByOptions: videosSortByCreatorTwitch,
  },
  boardVideosUploadDate: {
    ...newVideosDefaultValues,
    uploadDate: customUploadDateRangeSearchVideos[0],
  },
  searchVideosUploadDate: {
    ...newVideosDefaultValues,
    uploadDate: customUploadDateRangeSearchVideos[2],
    titleAnd: titleAnd[0],
    titleOr: titleOr[0],
    titleNot: titleNot[0],
  },
  newCreators: {
    providers: checkboxProvidersOptions,
    sortBy: searchCreatorsSortBy[0],
    sortByOptions: searchCreatorsSortBy,
    sortByWithVideoLikes: searchCreatorsTopicSortBy[0],
    sortByWithVideoLikesOpts: searchCreatorsTopicSortBy,
    creatorType: creatorType[0],
    dateRange: dateRangeSearch[0],
    creatorTypeOptions: creatorType,
    followedCreators: followedCreators,
    trendingCreators: trendingCreators,
    countries: countries[0],
    countriesOptions: countries,
    creatorTier: creatorTier[0],
    creatorTierOptions: creatorTier,
    title: title[0],
    topics: topic[0],
    language: language[3],
    topicCategory: topicCategory[0],
    musicSubgenre: musicSubgenre[0],
    musicGenre: musicGenre[0],
    subtopic: subtopic[0],
    dateRangeOverall: dateRangeButtons[0],
  },
  tagPage: {
    providers: providers,
    sortBy: videosSortBy[0],
    uploadDate: uploadDateSearchVideos[6],
  },
  topicSubtopicTab: {
    subtopicType: subtopicType[0],
    title: title[0],
    dateRange: uploadDateSearchTopics[0],
    dateRangeOptions: uploadDateSearchTopics,
  },
  trendingVideos: {
    tagTitle: tagTitle[0],
    sortBy: videosSortBy[0],
    sortByOptions: videosSortBy,
    providers: checkboxProvidersOptions,
    dateRange: dateRangeSearch[0],
    uploadDateOptions: uploadTrendingDates,
    language: language[3],
    title: title[0],
    uploadDate: uploadTrendingDates[2],
    lengthMin: length[0],
    lengthMax: length[length?.length - 1],
    lengthOptions: length,
    countries: countries[0],
    languages: [language[3]],
    categories: [topicCategory[0]],
    subtopics: [subtopic[0]],
    countriesOptions: countries,
    isLive,
    isAdvertisement,
  },
  trendingTags: {
    providers: providersWithGeneral,
    generalProvider: generalProviderType,
  },
  youtubeAuditComparePage: {
    comparing: compareTabs[0],
    dateRange: youtubeAuditDataRangeCompare[0],
    creators: [],
    subtopics: [],
    topics: [],
    savedPostSearches: [],
    niches: [],
    tags: [],
    industry_topic: [],
    global_topic: [],
    theme: [],
    segment: [],
    subject: [],
    entity_query: [],
    entity: [],
  },
}

export default filterDefaults
